import React from 'react';
import { Button, Container } from 'reactstrap';
import { REPORT_CONFIG_LIST_URL } from '../../Routes';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { sortBy } from 'lodash';
import { connect } from 'react-redux';

export const ConfigListPage = ({ items = [], history, onLoad, doDelete }) => {
  React.useEffect(() => {
    onLoad();
  }, []);

  return (
    <Container fluid className='config-list mt-3'>
      <Button type='button' outline color='primary' onClick={() => history.push(`${REPORT_CONFIG_LIST_URL}/new`)}>
        New Config
      </Button>

      {items?.map((e, i) => (
        <React.Fragment key={`${e.code}_${i}`}>
          <section className='d-flex justify-content-between my-3 d-flex justify-content-between'>
            <div className='h3 text-primary'>
              <Link to={`${REPORT_CONFIG_LIST_URL}/${e.code}`}>{`${e.bank} - ${e.seq}.  ${e.title}`}</Link>
            </div>
            <Button type='button' onClick={() => doDelete(e.code)}>
              Remove
            </Button>
          </section>
        </React.Fragment>
      ))}
    </Container>
  );
};

const fetchConfigList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: 'fetch_report_config_list_start' });
    let res = await axios.get('/api/report-configs');
    dispatch({ type: 'fetch_report_config_list_success', payload: res.data });
  } catch (err) {
    dispatch({ type: 'fetch_report_config_list_error', payload: err });
    throw err;
  }
};

const doDelete = (reportCd) => async (dispatch) => {
  try {
    await axios.delete(`/api/report-configs/${reportCd}`);
  } catch (err) {
    throw err;
  } finally {
    dispatch(fetchConfigList());
  }
};

const mapStateToProps = (state, props) => {
  let items = sortBy(state?.reportConfigs?.data, ['bank', 'seq']);

  return { items };
};

const mapDispatchToProps = { onLoad: fetchConfigList, doDelete };

export default connect(mapStateToProps, mapDispatchToProps)(ConfigListPage);
